import {isEmpty} from 'lodash';

const initialState = {
    isFetchingGetAllData: false,
    isFetchingChildAge: false,
    isFetchingChildResidence: false,
    isFetchingDeleteChild: false,

    unableUpdateChild : false,
    unableUpdateChildRes : false,
  
    moreThanChildren: "0",
    //CHILDREN
    underAge18: {
      no: {
        underAge18Status: "0",
      },
      yes: {
        numberOfChildren: "",
        childInfo: [{
          first_name: "",
          last_name: "",
          dob: "",
          childern_age: 0,
          place_birth: "",
          sex: 0,
        }],
        signVDOP: {
          isSignVDOP: "0",
        },
        unbornChildrenStatus: {
          isMotherPregnant: "0",
        },
      },
    },

    //ADDRESS
  
    addressConfidential: {
      no: {
        addressConfidentialStatus: "0",
      },
      yes: {
        sameResidence:[],
        childDetails : [{
          date_from: "",
          address_child: "",
          child_live: "",
          childrelation: "",
          confidential:"",
          child_live_cond:"",
          childRes: [{
            date_from: "",
            date_to: "",
            child_address: "",
            child_live_with: "",
            relationship: "",
          }]
        }],
        },
      },
  };
  
  const ChildInformationReducer = (state = initialState, action) => {
    switch (action.type) {
  
      //ALL FORM DATA
  
      case "REQUEST_ALL_DATA":
        return { ...state,
          isFetchingGetAllData: true,
          isFetchingChildAge: false,
          isFetchingChildResidence: false,
      
          unableUpdateChild : false,
          unableUpdateChildRes : false,
        
          moreThanChildren: "0",
          //CHILDREN
          underAge18: {
            no: {
              underAge18Status: "0",
            },
            yes: {
              numberOfChildren: "",
              childInfo: [{
                first_name: "",
                last_name: "",
                dob: "",
                childern_age: 0,
                place_birth: "",
                sex: 0,
              }],
              signVDOP: {
                isSignVDOP: "0",
              },
              unbornChildrenStatus: {
                isMotherPregnant: "0",
              },
            },
          },
      
          //ADDRESS
        
          addressConfidential: {
            no: {
              addressConfidentialStatus: "0",
            },
            yes: {
              sameResidence: [],
              childDetails : [{
                date_from: "",
                address_child: "",
                child_live: "",
                childrelation: "",
                confidential:"",
                child_live_cond:"",
                childRes: [{
                  date_from: "",
                  date_to: "",
                  child_address: "",
                  child_live_with: "",
                  relationship: "",
                }]
              }],
              },
            }};
      case "SUCCESS_ALL_DATA":
        console.log(action.payload.data.underAge18, "action.payload.data.underAge18")
        return {
          
          ...state,
          isFetchingGetAllData: false,  
          
          moreThanChildren: action.payload.data.moreThanChildren,
          underAge18: action.payload.data.underAge18,
             
          
          //ADDRESS
  
          addressConfidential: {
            no: {
              addressConfidentialStatus:
                action.payload.data.addressConfidential.no
                  .addressConfidentialStatus,
            },
            yes: {
              sameResidence: action.payload.data.addressConfidential.yes.sameResidence,
              childDetails : action.payload.data.addressConfidential.yes.childDetails,
            },
          },
        };
  
      case "ERROR_ALL_DATA":
        return { ...state, 
          isFetchingGetAllData: false };
  
  
      //CHILD RESIDENCE
      case "REQUEST_CHILD_RESIDENCE":
        return { ...state, 
          unableUpdateChildRes : true,
          isFetchingChildResidence: true };
      case "SUCCESS_CHILD_RESIDENCE":
        return {
          ...state,
          unableUpdateChildRes : false,
          isFetchingChildResidence: false,
  
          addressConfidential: {
            no: {
              addressConfidentialStatus:
                action.payload.child_live_at_same_Residence,
            },
            yes: {
              sameResidence: action.payload.sameResidence,
              childDetails : action.payload.childDetails,
            },
          },
        };
  
      case "ERROR_CHILD_RESIDENCE":
        return { ...state, 
          unableUpdateChildRes : true,
          isFetchingChildResidence: false };
  
      //CHILD AGE
      case "CI_REQUEST_CHILD_AGE":
        return { ...state, 
          unableUpdateChild : true,
          isFetchingChildAge: true };
      case "CI_SUCCESS_CHILD_AGE":
        
        return {
          ...state,
          unableUpdateChild : false,
          isFetchingChildAge: false,

           moreThanChildren: action.payload.moreThanChildren,
          underAge18: {
            no: {
              underAge18Status: action.payload.childUnder18,
            },
            yes: {
              childInfo: action.payload.data, 
              signVDOP: {
                isSignVDOP: action.payload.signVDOP,
              },
              unbornChildrenStatus: {
                isMotherPregnant: action.payload.unbornChildren,
              },
            },
          },
         };
  
      case "CI_ERROR_CHILD_AGE":
        return { ...state, 
          unableUpdateChild : true,
          isFetchingChildAge: false };


          case "REQUEST_DELETE_CHILD":
            return { ...state, isFetchingDeleteChild: true };
          case "SUCCESS_DELETE_CHILD":
            return {
              ...state,
              isFetchingDeleteChild: false,

              moreThanChildren: action.payload.moreThanChildren,
              underAge18: {
                no: {
                  underAge18Status: action.payload.childUnder18,
                },
                yes: {
                  childInfo: isEmpty(action.payload.data) ? initialState.childInfo: action.payload.data,
                  signVDOP: {
                    isSignVDOP: action.payload.signVDOP,
                  },
                  unbornChildrenStatus: {
                    isMotherPregnant: action.payload.unbornChildren,
                  },
                },
              },
            };
          case "ERROR_DELETE_CHILD":
            return { ...state, isFetchingDeleteChild: false };


      default:
        return state;
    }
  };
  
  export default ChildInformationReducer;
  